var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DashboardChartLine',{attrs:{"title":_vm.title,"labels":_vm.labels,"data":_vm.data,"height":_vm.height,"loading":_vm.loading,"color":"white","bg-color":_vm.bgColor,"dark":""}})}
var staticRenderFns = []

export { render, staticRenderFns }